<template>
  <section class="subscribe">
    <div class="container">
      <slot name="header"></slot>
      <slot name="content"></slot>
      <div v-show="!formSent">
        <!-- Begin Mailchimp Signup Form -->
        <div id="mc_embed_signup">
          <form
            action="https://petsnpirates.us10.list-manage.com/subscribe/post?u=37e2b7014e420a537c9cbafd7&amp;id=491c8a1428"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            @submit="track('button-subscribe', ecategory)"
          >
            <div id="mc_embed_signup_scroll">
              <div class="mc-field-group">
                <input
                  type="email"
                  value
                  name="EMAIL"
                  class="required email"
                  id="mce-EMAIL"
                  autocomplete="off"
                  v-model="email"
                  required
                />
                <input
                  type="submit"
                  value="Aye aye, Subscribe!"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  class="button"
                />
              </div>
              <div id="mce-responses" class="clear">
                <div class="response" id="mce-error-response" style="display:none"></div>
                <div class="response" id="mce-success-response" style="display:none"></div>
              </div>
              <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
              <div style="position: absolute; left: -5000px;" aria-hidden="true">
                <input
                  type="text"
                  name="b_37e2b7014e420a537c9cbafd7_491c8a1428"
                  tabindex="-1"
                  value
                />
              </div>
            </div>
          </form>
        </div>

        <!--End mc_embed_signup-->
        <div class="disclaimer">
          <p>
            You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices, please visit
            <router-link to="/privacy" target="_blank">this page.</router-link>
            <br />We use Mailchimp as our marketing platform. By subscribing, you acknowledge that your information will be transferred to Mailchimp for processing.
            <br />
            <a
              href="https://mailchimp.com/legal/"
              target="_blank"
            >Learn more about Mailchimp's privacy practices here.</a>
          </p>
        </div>
      </div>
      <div v-show="formSent">
        <h2 class="orange">Thanks for your subscription, Ahr!</h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "subscribe",
  data() {
    return {
      email: "",
      formSent: false,
    };
  },
  props: {
    ecategory: String,
  },
  methods: {
    track(action, category) {
      this.$gtag.event(action, {
        eventCategory: category,
      });
      window.fbq("trackCustom", action);
      let self = this;
      window.setTimeout(function () {
        self.formSent = true;
        self.email = "";
      }, 1200);
    },
  },
};
</script>

<style scoped lang="scss">
h2.orange {
  color: $orange;
}

.subscribe {
  p {
    margin-bottom: 1rem;
  }
  text-align: center;
  input.email {
    background: url("../../images/input.svg") no-repeat left center;
    border: none;
    outline: none;
    padding: 1rem;
    color: #333;
    font-size: 1.5rem;
    width: 90%;
    font-family: "Raleway", Arial, sans-serif;
    @media screen and (min-width: $desktop) {
      width: 25rem;
    }
  }
  input.button {
    background: url("../../images/button-subs.svg") no-repeat left center;
    padding: 1.5rem;
    border: none;
    outline: none;
    font-family: "Plumcake", "Times New Roman", serif;
    text-transform: uppercase;
    color: white;
    font-size: 2rem;
    margin-left: 1rem;
  }
  .disclaimer {
    margin-top: 1rem;
    p {
      font-size: 0.8rem;
      line-height: 0.9rem;
      a {
        color: darken($green, 10%);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>